import React, { useEffect, useMemo } from 'react';
import Dialog from '@shared/ui/molecules/Dialog';
import { useDispatch, useSelector } from "react-redux";
import { closeDialog } from '@shared/store/dialog.duck';
import styled from "styled-components";
import {
  initMeetingRoomBookingDialog,
  MeetingRoomBookingViewPanel,
  reset,
  selectActivePanel,
  selectIsMeetingRoomBookingDialogBookingsLoading
} from "../models/meeting-room-booking-dialog.duck";
import { MeetingRoomBookingPanel } from "./components/MeetingRoomBookingPanel";
import { AddRemoveAttendeesPanel } from "./components/AddRemoveAttendeesPanel";
import { AddRemoveVisitorsPanel } from "./components/AddRemoveVisitorsPanel";
import { selectAllOfficeEntities } from '@features/desks/store/advanceHotDeskingSetup.duck';
import { getRootOfficeById } from '@shared/utils/OfficeHelper';
import { AddInstructionsPanel } from "./components/AddInstructionsPanel";
import { AddSpecialItemsPanel } from "./components/AddSpecialItemsPanel";
import { AddItemsFromMenuPanel } from "./components/AddItemsFromMenuPanel";
import { selectActiveDay } from '@features/whereabouts/store/editMovements.duck';
import { Center } from '@shared/ui/atoms/StructuralLayout';
import { LoadingSpinner } from '@shared/ui/atoms/LoadingSpinner';
import { smallTablet } from '@shared/ui/atoms/MediaQueries';

export function MeetingRoomBookingDialogV2(props: Props) {
  const {hour, minutes, meetingRoom, meetingBooking} = props.payload;
  const dispatch = useDispatch();
  const activePanel = useSelector(selectActivePanel);
  const allOffices = useSelector(selectAllOfficeEntities);
  const activeDay = useSelector(selectActiveDay);
  const isLoading = useSelector(selectIsMeetingRoomBookingDialogBookingsLoading);

  const rootOffice = useMemo(() => {
    return getRootOfficeById(allOffices, meetingRoom.officeId);
  }, [allOffices, meetingRoom.officeId])

  useEffect(() => {
    if (meetingRoom && rootOffice) {
      dispatch(initMeetingRoomBookingDialog({
        hour, minutes, meetingRoom, rootOffice, meetingBooking, activeDay
      }));
    }
  }, [activeDay, dispatch, hour, meetingBooking, meetingRoom, minutes, rootOffice]);

  const close = () => {
    dispatch(closeDialog());
  }

  useEffect(() => {
    return () => {
      dispatch(reset());
    }
  }, [dispatch]);

  return (
    <>

      <DialogWrapper isOpen={true} onClose={close} showLogo={true}>
        {isLoading ? <>
          <Center>
            <LoadingSpinner fullScreen={false} hideBorder={true} hideText={true} />
          </Center>
        </> : <>
          {activePanel === MeetingRoomBookingViewPanel.MeetingRoomBooking && <MeetingRoomBookingPanel />}
          {activePanel === MeetingRoomBookingViewPanel.AddRemoveAttendees && <AddRemoveAttendeesPanel />}
          {activePanel === MeetingRoomBookingViewPanel.AddRemoveVisitors && <AddRemoveVisitorsPanel />}
          {activePanel === MeetingRoomBookingViewPanel.AddInstructions && <AddInstructionsPanel />}
          {activePanel === MeetingRoomBookingViewPanel.AddItemsFromMenu && <AddItemsFromMenuPanel />}
          {activePanel === MeetingRoomBookingViewPanel.AddSpecialItems && <AddSpecialItemsPanel />}
        </>}
      </DialogWrapper>
    </>
  )
}

interface Props {
  payload: any;
}


const DialogWrapper = styled(Dialog)<any>`
  padding: 0;
  max-width: 100%;
  width: 684px;
  max-height: 80vh;
  height: 690px;
  .dialog__close {
    color: white;
  }
  .dialog__contentContainer {
    height: 100%;
    max-height: 100vh;
    @media (${smallTablet}) {
      max-height: 80vh;
    }
  }
  .dialog__content {
    max-width: 100%;
    padding: 0;
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 100%;
  }
`
